<template>
  <ib-dialog v-model="dialog" width="720" scrollable>
    <v-card>
      <ib-dialog-header title="Agendamento de envio" subtitle="Envie mensagens individualmente por aqui. Você pode disparar imediatamente ou agendar o envio." :close="closeDialog"></ib-dialog-header>

      <v-card-text>
        <v-row class="pt-1 mt-0">
          <v-col cols="12" lg="8" md="8" sm="12">
            <v-row>
              <v-col cols="4">
                <ib-text-field v-model="country_code" outlined label="Cód País" hide-details="auto" />
              </v-col>
              <v-col cols="8">
                <ib-text-field v-model="object.to" label="Número destino" placeholder="Insira um número com DDD, exemplo: 11955555555" outlined hide-details="auto" />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" lg="4" md="4" sm="12">
            <ib-select v-model="object.chip" @change="onChipChange" clearable item-text="name" item-value="_id" :items="chips" label="Chip de envio" outlined hide-details="auto" return-object />
          </v-col>

          <v-col cols="12" v-if="isOfficialChip">
            <ib-select v-model="object.template" :loading="loadingTemplates" outlined :items="availableTemplates" item-text="name" return-object no-data-text="Não há templates aprovados" item-value="name" label="Template de mensagem" hide-details="auto" messages="Apenas templates com conteúdo fixo (sem parâmetros, variáveis ou imagens)" />
          </v-col>

          <v-col cols="12" v-if="!isOfficialChip && object.chip">
            <ib-select v-model="object.type" clearable item-text="name" item-value="id" :items="types" label="Tipo de conteúdo" outlined hide-details="auto" />
          </v-col>

          <v-col v-if="object.type == 'flow'" cols="12">
            <ib-autocomplete v-model="object.flow" clearable item-text="name" item-value="_id" :items="flows" label="Fluxo" outlined hide-details="auto" />
          </v-col>

          <v-col v-if="object.type == 'text'" cols="12">
            <v-textarea class="nd-text-field" v-model="object.message" rows="4" label="Texto da mensagem" placeholder="Escreva aqui a mensagem de texto que será enviada." outlined hide-details="auto" messages="Mensagens do tipo texto serão enviadas, mas só criarão uma nova conversa na plataforma após a resposta do contato (para evitar que o chatbot interfira em conversas pessoais iniciadas por você diretamente no celular)" />
          </v-col>

          <v-col cols="12">
            <label class="mb-2"><b>Quando a mensagem deverá ser enviada?</b></label>

            <v-datetime-picker v-model="object.scheduledTo" label="Data e hora do envio" date-format="dd/MM/yyyy" :date-picker-props="{ locale: 'pt-BR' }" :time-picker-props="{ format: '24hr' }" :text-field-props="{ outlined: true }">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>

              <template slot="timeIcon">
                <v-icon>mdi-clock-outline</v-icon>
              </template>

              <template slot="actions" slot-scope="{ parent }">
                <ib-btn color="gray200" outlined @click.native="parent.clearHandler">
                  <div class="gray1000--text">
                    Cancelar
                  </div>
                </ib-btn>
                <ib-btn color="primary" @click="parent.okHandler">
                  OK
                </ib-btn>
              </template>
            </v-datetime-picker>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>

        <ib-btn outlined color="gray200" @click="closeDialog">
          <div class="gray1000--text">
            Cancelar
          </div>
        </ib-btn>

        <v-spacer />

        <ib-btn color="primary" :loading="loading" @click="createNew">
          Salvar
        </ib-btn>
      </v-card-actions>
    </v-card>
  </ib-dialog>
</template>

<script>
import Api from '@/lib/Api';
import { emitToastr, onlyNumbers, formatPhone, isStaticTemplate } from '@/lib/Utils';

export default {
  props: {
    value: Boolean,
    chips: Array,
    currentChip: String,
    flows: Array,
    templates: Array,
    phone: String,
    allMessage: Object,
    callback: Function
  },
  data() {
    return {
      loading: false,
      loadingTemplates: false,
      object: {},
      country_code: '55',
      internalTemplates: [],
      types: [
        { id: 'text', name: 'Texto' },
        { id: 'flow', name: 'Fluxo' },
      ]
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    isOfficialChip() {
      return this.object.chip?.official === true;
    },
    availableTemplates() {
      const templates = this.templates && this.templates.length > 0 ? this.templates : this.internalTemplates;
      return templates.filter(t => isStaticTemplate(t.components));
    }
  },
  watch: {
    dialog: {
      handler() {
        if (this.dialog) {
          let data = { to: '', chip: null, type: null, message: '', flow: null, template: null, scheduledTo: null };

          if (!this.allMessage) {
            this.country_code = this.phone.slice(0,2);
            data.to = (this.phone || '').slice(2);
          }
          else {
            data = { ...data, ...this.allMessage };
            if (data.scheduledTo) data.scheduledTo = new Date(data.scheduledTo);
            if (data.chip) {
              data.chip = this.chips.find(chip => chip._id === data.chip) || null;
            }
          }

          if (this.currentChip) data.chip = this.chips.find(chip => chip._id === this.currentChip) || null;

          this.object = data;

          if (this.isOfficialChip) {
            this.changeTemplates(true);
          }
        }
      },
    }
  },
  async mounted() {

  },
  methods: {
    onChipChange() {
      if (this.isOfficialChip) {
        this.object.type = null;
        this.object.message = '';
        this.object.flow = null;
      }

      this.changeTemplates();
    },

    async changeTemplates(keepTemplate = false) {
      this.internalTemplates = [];
      if (!keepTemplate) this.object.template = null;

      if (this.object.chip && this.object.chip.waba) {
        this.loadingTemplates = true;
        const templates = await Api.getTemplateMessages(this.object.chip.waba);
        this.loadingTemplates = false;
        
        if (!templates.error && templates.message) {
          this.internalTemplates = templates.message.filter(t => t.status === 'APPROVED' && isStaticTemplate(t.components));
        }
      }
    },

    clear() {
      this.loading = false;
    },

    closeDialog() {
      this.clear();
      this.dialog = false;
    },

    async createNew() {
      if (!this.object.chip) return emitToastr("error", "Chip de envio necessário");
      if (!this.object.to) return emitToastr("error", "Número de destino necessário");
      if (!this.object.scheduledTo) return emitToastr("error", "Data e hora do agendamento necessárias");

      this.object.to = formatPhone(this.object.to, false);

      if (!onlyNumbers(this.object.to)) return emitToastr("error", "Número de telefone inválido.");
      if (!onlyNumbers(this.country_code)) return emitToastr("error", "Código do país inválido.");

      if (!this.isOfficialChip) {
        if (this.object.type == 'text' && !this.object.message) return emitToastr("error", "Texto da mensagem necessário");
        if (this.object.type == 'flow' && !this.object.flow) return emitToastr("error", "Fluxo necessário");
      }
      else {
        if (!this.object.template) return emitToastr("error", "Template de mensagem necessário para número de API Oficial");
      }

      this.loading = true;
      let resp;

      this.object.to = this.country_code + this.object.to;

      // Preparar dados para envio
      const dataToSend = {
        ...this.object,
        chip: this.object.chip?._id || this.object.chip,
        template: this.isOfficialChip ? this.object.template : undefined,
      };

      if (this.object._id) {
        resp = await Api.updateScheduledMessage(dataToSend);
      }
      else {
        resp = await Api.createScheduledMessage(dataToSend);
      }

      this.loading = false;

      if (!resp.error) {
        this.object = { to: "", message: "" };
        emitToastr("success", "Agendamento cadastrado com sucesso.");
        if (this.callback) this.callback();
        this.closeDialog();
      }
    },
  }
};
</script>

<style></style>